module.exports = {
  socketIo: "https://api2.devs.automate.video",
  /*socketIo: "https://rechart-dev-api.azurewebsites.net", */
  playerkey: "SDFJIWR3sssdgwwerweWLK23423424!sldkfj9s49g499g4cccf",
  debug: true,
  analyticsUrl:
    "https://rechart-funcapp.azurewebsites.net/api/analytics-addToQueue?code=QF0/SXlAPokVZ0wvQluc7fa3r6GgZNaiD4gRd91OhhAbc5pEC9pXyA=="
};
